import { AJAX_TIMEOUT_MESSAGE } from '../helpers.js';
import { cleanupBootstrapModalBody } from '../shared/bootstrap-modal-cleanup.js';
import { getMemberOverlayElement, showOverlay, hideOverlay } from '../shared/overlay.js';
import { openIndexPage } from './member-open-index-page.js';
import { showAlertMsg } from './member-show-alert-msg.js';

const CONFIG_SCRIPT_ID = 'card-otp-modal-config';
const NS = '.cardOtpModal';

function readConfig() {
    const el = document.getElementById(CONFIG_SCRIPT_ID);
    if (!el) {
        throw new Error('initCardOtpModal: #' + CONFIG_SCRIPT_ID + ' script tag is required');
    }
    return JSON.parse(el.textContent || '{}');
}

function getModal() {
    return $('#cardOtpModal');
}

function closeModal() {
    const $modal = getModal();
    $modal.modal('hide');
    $modal.find('#otp').val('');
    $modal.find('#ModalErrMsg, #ModalResendMsg').hide();
}

function sendOtp(config) {
    return $.ajax({
        url: config.routes.sendOtp,
        type: 'POST',
        data: { _token: config.csrfToken },
    });
}

export function requestCardOtpVerification(payload, confirmUrl, verifiedCallback) {
    const config = readConfig();
    getModal().data({ payload: payload, confirmUrl: confirmUrl, onVerified: verifiedCallback });
    sendOtp(config)
        .done(function (response) {
            if (!response.success) {
                showAlertMsg(response.error, 'danger');
                return;
            }
            getModal().modal('show');
        })
        .fail(function () {
            showAlertMsg(AJAX_TIMEOUT_MESSAGE, 'danger');
        });
}

function resendOtp(config) {
    const $modal = getModal();
    sendOtp(config)
        .done(function (response) {
            if (!response.success) {
                $modal.find('#ModalErrMsg').show();
                $modal.find('#pin_err').html(response.error);
            } else {
                $modal.find('#ModalResendMsg').show();
                $modal.find('#resend_msg').html('The pin was texted to you.  Please enter that pin above.');
            }
        })
        .fail(function () {
            showAlertMsg(AJAX_TIMEOUT_MESSAGE, 'danger');
        });
}

function confirmOtp(config) {
    const $modal = getModal();
    const payload = $modal.data('payload');
    const confirmUrl = $modal.data('confirmUrl');
    const onVerified = $modal.data('onVerified');
    $.ajax({
        url: confirmUrl,
        type: 'POST',
        data: Object.assign({}, payload, {
            otp: $modal.find('#otp').val(),
            _token: config.csrfToken,
        }),
        success: function (response) {
            hideOverlay(getMemberOverlayElement());
            if (!response.success) {
                $modal.find('#ModalErrMsg').show();
                $modal.find('#pin_err').html(response.error);
                return;
            }
            closeModal();
            cleanupBootstrapModalBody();
            if (onVerified) {
                onVerified(response);
            }
        },
        error: function () {
            hideOverlay(getMemberOverlayElement());
            closeModal();
            cleanupBootstrapModalBody();
            showAlertMsg(AJAX_TIMEOUT_MESSAGE, 'danger');
            openIndexPage();
        },
    });
}

export function initCardOtpModal() {
    const config = readConfig();

    $(document).off(NS).on('click' + NS, '[data-action="close-card-otp-modal"]', function (e) {
        e.preventDefault();
        closeModal();
    });

    $(document).on('click' + NS, '[data-action="resend-otp-pin"]', function (e) {
        e.preventDefault();
        resendOtp(config);
    });

    $(document).on('submit' + NS, '#cardOtp', function (e) {
        e.preventDefault();
        $(this).find('#ModalErrMsg, #ModalResendMsg').hide();
        showOverlay(getMemberOverlayElement());
        confirmOtp(config);
    });
}
